import { Id } from "PFTypes";

import api from "../api";

export const fetchCvTemplates = (accountId: Id, params?) =>
  api({ url: "cv_templates", params: { accountId, ...params } });

export const createCvTemplate = (data): Promise<void> => api({ url: "cv_templates", method: "POST", data });

export const updateCvTemplate = (id: Id, data): Promise<void> =>
  api({ url: `cv_templates/${id}`, method: "PUT", data });

export const fetchCvTemplate = (templateId: Id, accountId: Id) =>
  api({ url: `cv_templates/${templateId}`, params: { accountId } });

export const removeCvTemplate = (accountId: Id, id: Id): Promise<void> =>
  api({
    url: `cv_templates/${id}`,
    data: { accountId },
    method: "DELETE"
  });
